@let currentLanguage = this.currentLanguage();
@let isFrench = currentLanguage === 'fr-CA';

<div class="content">
  @if (isFrench) {
    <img
      src="/images/service-center-sections/more-app-content-fr.svg"
      width="748"
      height="380"
      alt="App Content"
    />
  } @else {
    <img
      src="/images/service-center-sections/more-app-content-en.svg"
      width="606"
      height="380"
      alt="App Content"
    />
  }
</div>

<div class="links">
  <div class="col">
    @let appStoreUrlEn = 'https://oon.gl/hdWDhY';
    @let appStoreUrlFr = 'https://oon.gl/dutxRd';

    <app-qrcode
      class="qr-code"
      variant="blue"
      logo="/images/service-center-sections/more-app-qrcode-app-store-logo.webp"
      [content]="isFrench ? appStoreUrlFr : appStoreUrlEn"
      [size]="400"
    />
  </div>

  <div class="col">
    @let googlePlayUrlEn = 'https://oon.gl/yDekrB';
    @let googlePlayUrlFr = 'https://oon.gl/cQhUxx';

    <app-qrcode
      class="qr-code"
      variant="blue"
      logo="/images/service-center-sections/more-app-qrcode-google-play-logo.webp"
      [content]="isFrench ? googlePlayUrlFr : googlePlayUrlEn"
      [size]="400"
    />
  </div>
</div>

<div class="preview">
  <img
    src="/images/service-center-sections/more-app-preview.webp"
    width="740"
    height="290"
    alt="App Preview"
  />
</div>
